import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "searchFrom" }
const _hoisted_2 = { style: {"margin-top":"20px"} }
const _hoisted_3 = {
  key: 0,
  style: {"color":"#faad14","font-size":"12px","margin-top":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_XAtable = _resolveComponent("XAtable")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_x_dialog = _resolveComponent("x-dialog")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_form, {
        name: "customized_form_controls",
        layout: "inline",
        model: $setup.searchFormState
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, { label: "用户账号" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: $setup.searchFormState.account,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchFormState.account) = $event)),
                placeholder: "输入用户账号"
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, { label: "角色" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: $setup.searchFormState.roleId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchFormState.roleId) = $event)),
                placeholder: "请选择角色",
                "allow-clear": "",
                style: {"min-width":"150px"},
                loading: $setup.roleListLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roleList, (role) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: role.id,
                      value: role.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(role.roleName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                style: {"margin-right":"10px"},
                onClick: $setup.resetForm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重置")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: $setup.search,
                style: {"margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("搜索")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: $setup.addClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 添加 ")
                ]),
                _: 1
              }, 8, ["onClick"])), [
                [_directive_permission, 'sysUser.list.add']
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_XAtable, {
        columns: $setup.columns,
        dataSource: $setup.tableData,
        loading: $setup.loading,
        scroll: { x: 600 }
      }, {
        status: _withCtx(({ scope }) => [
          _createElementVNode("span", null, _toDisplayString(scope.record.status === 1 ? "启用" : "禁用"), 1)
        ]),
        control: _withCtx(({ scope }) => [
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.editClick(scope.record)),
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("编辑")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'sysUser.list.update']
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_a_button, {
            type: "primary",
            size: "small",
            onClick: ($event: any) => ($setup.copyCode(scope.record)),
            style: {"margin-right":"10px"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("推广链接")
            ]),
            _: 2
          }, 1032, ["onClick"])), [
            [_directive_permission, 'sysWork.list.read']
          ])
        ]),
        _: 1
      }, 8, ["columns", "dataSource", "loading"]),
      _createVNode(_component_a_pagination, {
        current: $setup.pageNo,
        "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => (($setup.pageNo) = $event)),
        onChange: $setup.pageNoChange,
        total: $setup.total,
        hideOnSinglePage: "",
        onShowSizeChange: $setup.onShowSizeChange,
        style: {"margin-top":"5px"}
      }, null, 8, ["current", "onChange", "total", "onShowSizeChange"])
    ]),
    _createVNode(_component_x_dialog, {
      title: $setup.isAdd ? '添加' : '编辑',
      visible: $setup.dislogVisible,
      onCancel: $setup.handleCancel,
      onConfirm: $setup.confirm,
      loading: $setup.addLoading,
      onIsDestroyOnClose: _cache[11] || (_cache[11] = ($event: any) => {$setup.addLoading = false;})
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: $setup.formState,
          ref: "formRef",
          labelCol: { span: 4, offset: 0 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "用户账号",
              name: "account",
              rules: [{ required: true, message: '请输入用户账号!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入用户账号(登录账号)",
                  value: $setup.formState.account,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (($setup.formState.account) = $event)),
                  disabled: !$setup.isAdd,
                  onInput: _cache[4] || (_cache[4] = ($event: any) => ($setup.limitAccountInput($event, 'form')))
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "用户名",
              name: "name",
              rules: [{ required: true, message: '请输入用户名!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入用户名",
                  value: $setup.formState.name,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (($setup.formState.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "密码",
              name: "password",
              rules: [{ required: $setup.isAdd, message: '请输入密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_group, { compact: "" }, {
                  default: _withCtx(() => [
                    (!$setup.isAdd && $setup.newPassword)
                      ? (_openBlock(), _createBlock(_component_a_input, {
                          key: 0,
                          value: $setup.newPassword,
                          readonly: "",
                          style: {"width":"calc(100% - 160px)","cursor":"default"},
                          onKeydown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                        }, null, 8, ["value"]))
                      : (_openBlock(), _createBlock(_component_a_input, {
                          key: 1,
                          type: "password",
                          placeholder: $setup.isAdd ? '请输入密码' : '••••••••',
                          value: $setup.formState.password,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (($setup.formState.password) = $event)),
                          disabled: !$setup.isAdd,
                          style: {"width":"calc(100% - 88px)"}
                        }, null, 8, ["placeholder", "value", "disabled"])),
                    (!$setup.isAdd && $setup.newPassword)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 2,
                          onClick: $setup.copyNewPassword,
                          style: {"width":"72px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("复制")
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (!$setup.isAdd)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 3,
                          type: "primary",
                          loading: $setup.resetPasswordLoading,
                          onClick: $setup.handleResetPassword,
                          style: {"width":"88px"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("重置密码")
                          ]),
                          _: 1
                        }, 8, ["loading", "onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (!$setup.isAdd && $setup.newPassword)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ⚠ 密码请妥善保管，服务端不记录 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["rules"]),
            _createVNode(_component_a_form_item, {
              label: "角色",
              name: "roleId",
              rules: [{ required: true, message: '请选择角色!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: $setup.formState.roleId,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => (($setup.formState.roleId) = $event)),
                  placeholder: "请选择角色",
                  loading: $setup.roleListLoading
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.roleList, (role) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: role.id,
                        value: role.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(role.roleName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  name: "status",
                  value: $setup.formState.status,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (($setup.formState.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("启用")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("禁用")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "商务联系",
              name: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  placeholder: "商务联系",
                  value: $setup.formState.remark,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => (($setup.formState.remark) = $event)),
                  rows: 3,
                  maxlength: 100,
                  "show-count": true
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible", "onCancel", "onConfirm", "loading"])
  ], 64))
}